import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DashboardPopup from '../DashboardPopup'
import Button from 'components/UI/Button/Button'
import {
  Title,
  Subtitle,
  EmailList,
  Note,
  ButtonRow,
  Footnote
} from './EmailErrorPopup.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class EmailErrorPopup extends Component {
  static propTypes = {
    emails: PropTypes.arrayOf(PropTypes.string)
  }

  render () {
    return (
      <DashboardPopup
        onCancel={this.props.onCancel}
        isSettings
      >
        <Title>
          Whoops!
        </Title>
        <Subtitle>
          The following e-mail addresses could not be added to your school:
        </Subtitle>
        <EmailList>
          {this.props.emails.join(', ')}
        </EmailList>
        <Note>
          Please make sure that all your teachers have an existing Night Zookeeper account
        </Note>
        <ButtonRow>
          <Button
            bgColor={colors.lightBlue}
            color='white'
            size='regular'
            width='105px'
            height='30px'
            onClick={this.props.onCancel}
          >
            OK
          </Button>
        </ButtonRow>
      </DashboardPopup>
    )
  }
}
